import { render, staticRenderFns } from "./dialog-box.vue?vue&type=template&id=59d999e9&scoped=true"
import script from "./dialog-box.vue?vue&type=script&lang=js"
export * from "./dialog-box.vue?vue&type=script&lang=js"
import style0 from "./dialog-box.vue?vue&type=style&index=0&id=59d999e9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d999e9",
  null
  
)

export default component.exports